import { ChangeEvent, FC, useRef, useState } from 'react';
import classes from './index.module.scss';
import React from 'react';
import IconButton from 'components/generics/buttons/IconButton';
import Typography from 'components/generics/texts/Typography';
import { ClipLoader, SyncLoader } from 'react-spinners';

interface Props {
  accept?: any;
  value: any;
  setValue: (file: any) => void;
}

export const UploadPhotoInput: FC<Props> = ({
  accept = 'image/*',
  value,
  setValue,
}) => {
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImageUploadClick = () => {
    fileInputRef.current?.click();
  };

  const updateImage = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setLoading(true);
      setValue(file);
      setLoading(false);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const handleFileDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (event.dataTransfer.files && event.dataTransfer.files[0]) {
      const file = event.dataTransfer.files[0];
      setValue(file);
    }
  };

  const handleClose = () => {
    setValue(null);
  };

  return (
    <div
      className={
        !value && !loading ? classes.dropZone : classes.uploadedDropZone
      }
      onDragOver={handleDragOver}
      onDrop={handleFileDrop}
      onClick={handleImageUploadClick}
    >
      {value ? (
        <div className={classes.imageContainer}>
          <Typography className={classes.uploadedImage}>
            {value.name}
          </Typography>
          <IconButton
            className={classes.closeIcon}
            variant="close"
            onClick={handleClose}
          />
        </div>
      ) : (
        <div className={classes.innerContainer}>
          {!loading ? (
            <>
              <img
                src="https://cdn.prod.website-files.com/5e481500baff8f1b46a42ced/661448d13c487e20f442f1bf_Upload.svg"
                alt="Upload"
              />
              <span>Upload Photo</span>
            </>
          ) : (
            <>
              <ClipLoader
                color="black"
                size={20}
              />
              <Typography>Uploading...</Typography>
            </>
          )}
        </div>
      )}
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        style={{ display: 'none' }}
        onChange={updateImage}
        disabled={value !== null}
      />
    </div>
  );
};
